/**
 * Can not rasterize svg with value 'currentColor' and 'inherit' in fill attribute.
 * Replace these values with actual color codes.
 */
const setSvgColorsExplicitly = () => {
	const svgElements = window.document.querySelectorAll('svg *[fill]');

	for (let i = 0; i < svgElements.length; i += 1) {
		let fillAttr = svgElements[i].getAttribute('fill') || '';
		const styleParent = svgElements[i].closest('span');

		if (styleParent) {
			const parentStyle = getComputedStyle(styleParent);

			// Fix for the primary color of dependency badge
			// Copy the grand parent primary color to the span --icon-primary-color.
			if (parentStyle.getPropertyValue('--icon-primary-color') === 'currentColor') {
				const grandParent = styleParent.closest('*');
				// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
				const grandParentStyle = getComputedStyle(grandParent!);
				styleParent.style.setProperty('--icon-primary-color', grandParentStyle.color);
			}
			if (fillAttr.indexOf('currentColor') > -1 && styleParent) {
				fillAttr = parentStyle.getPropertyValue('--icon-primary-color') || fillAttr;
			} else if (fillAttr.indexOf('inherit') > -1 && styleParent) {
				fillAttr = parentStyle.getPropertyValue('--icon-secondary-color') || fillAttr;
			}
			svgElements[i].setAttribute('fill', fillAttr);
		}
	}
};

/**
 * Set SVG widths and heights
 */
const setSvgWidthAndHeight = () => {
	const svgs = window.document.querySelectorAll('svg');
	for (let i = 0; i < svgs.length; i += 1) {
		const svg = svgs[i];
		// Remove previously set width and height from dependencies overlay
		if (svg.classList.contains('dependencies-overlay')) {
			svg.removeAttribute('width');
			svg.removeAttribute('height');
		}
		// Set absolute width and height to all SVG that doesn't have these attributes defined.
		if (!svg.getAttribute('width') || !svg.getAttribute('height')) {
			const { width, height } = svg.getBoundingClientRect();
			svg.setAttribute('width', `${Math.round(width)}`);
			svg.setAttribute('height', `${Math.round(height)}`);
		}
	}
};

export const preparePlanForExport = () => {
	setSvgColorsExplicitly();
	setSvgWidthAndHeight();
};
